import { useCallback } from "react";
import type { FieldElement, UseFormMethods } from "react-hook-form";

export enum FORM_STATUS {
    NONE,
    SAVING_FORM
}

export function useRegisterRef(register: UseFormMethods["register"]) {
    return useCallback(
        (ref: FieldElement | null) => {
            if (ref) {
                const registerElement = register as (ref: FieldElement | null) => void;
                registerElement(ref);
            }
        },
        [register]
    );
}
